import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from "vue";

import { use_validation_group } from "@/composables/use_validation";

// TODO: when we upgrade to Vue>=3.3, components using use_validation_group can
// just import ValidatedInputEmitTypes to define the components emits (can be used to
// define an intersection type for emits as well).
// i.e.
// type EmitTypes = ValidatorEmitTypes & {
//   (e: "submit"): void
// }
// See https://vuejs.org/guide/typescript/composition-api.html#syntax-limitations
type EmitTypes = {
  (e: "update:is_valid", value: boolean): void;
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'NewValidatedForm',
  emits: ["update:is_valid", "submit"],
  setup(__props, { emit }: { emit: ({
  (e: "update:is_valid", value: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {


const all_valid = use_validation_group(emit);

const event_listeners = computed(() => {
  let listeners = { ...getCurrentInstance()?.proxy.$listeners };
  listeners.submit = handle_submit;
  return listeners;
});

const handle_submit = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  if (all_valid.value) {
    emit("submit");
  }
};

return { __sfc: true,emit, all_valid, event_listeners, handle_submit }
}

})